import axios from "../../../../../services/api";
import Axios, {AxiosResponse} from "axios";
import {getEnv} from "../../../../../api";
import {PaginationParamProps} from "../../../../hooks";
import {SolicitacaoDeVinculoInterface, Status} from "../../../../interfaces";

export interface IServiceInterface {
  findAll: (
      params: PaginationParamProps,
      body: Record<string, any>,
      controller?: AbortController | AbortSignal
  ) => Promise<any>;
  getOptions: () => Promise<any>;
  create: (body: SolicitacaoDeVinculoInterface) => Promise<any>;
  read: (id: string | number) => Promise<any>;
  update: (body: SolicitacaoDeVinculoInterface) => Promise<any>;
  getPendants?: (body?: SolicitacaoDeVinculoInterface) => Promise<any>;
  delete: (id: {
    id: string | number
  }) => Promise<any>;
  updateStatus: ({id, status}: {
    id: any;
    status: Status;
  }) => Promise<any>;
  associar: (cpf: string, cnpj: string, donoEmpresa: string) => Promise<any>;
  desassociar: (cpf: string, cnpj: string) => Promise<any>;
}

export const SolicitacaoDeVinculoService: IServiceInterface = {

  findAll: async (params, body = {}, controller) => {
    try {
      // @ts-ignore
      const response: AxiosResponse = await axios.post(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/vinculos/consultar`,
        body,
        { params, signal: controller}
      );
      return response.data;
    } catch (error: any) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada");
      } else {
        console.log(error.message);
        throw error;
      }
    }
  },

  read: async (id) => {
    try {
      if (!id) return;

      // @ts-ignore
      const response = await axios.get(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/atendimentos-sas/tipos/${id}`
      );
      return response.data;
    } catch (error) {
     throw error;
    }
  },

  update: async (body) => {
    try {
      // @ts-ignore
      const response = await axios.put(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/temas`,
        body
      );
      return response.data;
    } catch (error) {
     throw error;
    }
  },
  create: async (body) => {
    try {
      // @ts-ignore
      const response = await axios.post(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao`,
          body
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getOptions: async () => {
    try {
      // @ts-ignore
      const response = await axios.get(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/opcoes`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },


  delete: async (id) => {
    try {
      // @ts-ignore
      const response = await axios.delete(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/${id} `
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async ({id}) => {
    try {
      // @ts-ignore
      const response = await axios.put(
          `${await getEnv('REACT_APP_URL_SERVICE')}/v1/manutencao/status?id=${id}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  associar: async (cpf: string, cnpj: string, donoEmpresa: string): Promise<any> => {
    try {
      // @ts-ignore
      const url = `${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/cpf/${cpf}/associar/empreendedor/cnpj/${cnpj}/dono-da-empresa/${( donoEmpresa === 'OUTRO' ? false : true)}`;
      // @ts-ignore
      return await axios.put(url);
    } catch (error) {
      throw error;
    }
  },
  desassociar: async (cpf: string, cnpj: string): Promise<any> => {
    try {
      const url = `${await getEnv('REACT_APP_URL_SERVICE')}/v1/administradores/cpf/${cpf}/desassociar/empreendedor/cnpj/${cnpj}`;
      // @ts-ignore
      return await axios.put(url);
    } catch (error) {
      throw error;
    }
  },
};
